import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-background-jobs-info-dialog', {
    attrs: {
      "item-info-prop": _vm.itemInfo,
      "isOpen": _vm.isOpen
    },
    on: {
      "close": function ($event) {
        return _vm.closeDialog();
      }
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.title-bg-jobs'),
      "subtitle": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.subtitle-bg-jobs'),
      "buttons": _vm.buttonsList
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c(VTabs, {
    staticClass: "px-1",
    attrs: {
      "center-active": "",
      "grow": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _vm._l(_vm.allowedTabs, function (tb) {
    return _c(VTab, {
      key: tb.key,
      attrs: {
        "href": '#' + tb.key
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$i18n_t(tb.translationKey))
      }
    });
  }), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c(VTabItem, {
    key: "#file-export",
    staticClass: "pt-3",
    attrs: {
      "value": "file-export"
    }
  }, [_c('core-background-jobs-list', {
    ref: "list",
    attrs: {
      "resources": _vm.iotHubExportResources
    }
  })], 1), _c(VTabItem, {
    key: "#csv-bulk-export",
    staticClass: "pt-3",
    attrs: {
      "value": "csv-bulk-export"
    }
  }, [_vm.accountFilterReady ? _c('core-background-jobs-export-table', {
    ref: "list",
    attrs: {
      "accounts": _vm.selectedAccounts,
      "searchTypes": _vm.searchTypes,
      "jobType": 'deviceStatesCsvExport',
      "backgroundJobResources": _vm.twinExportResources
    },
    on: {
      "load-items": _vm.getItemsResults,
      "show-item-info": _vm.showInfo
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "#bg-jobs-edit",
    staticClass: "pt-3",
    attrs: {
      "value": "bg-jobs-edit",
      "data-cy": "background_edit_jobs_tab"
    }
  }, [_vm.accountFilterReady ? _c('core-background-jobs-table', {
    ref: "list",
    attrs: {
      "accounts": _vm.selectedAccounts,
      "searchTypes": _vm.searchTypes,
      "jobType": 'virtualDevicesEdit'
    },
    on: {
      "load-items": _vm.getItemsResults,
      "show-item-info": _vm.showInfo
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "#bg-jobs-import",
    staticClass: "pt-3",
    attrs: {
      "value": "bg-jobs-import"
    }
  }, [_vm.accountFilterReady ? _c('core-background-jobs-table', {
    ref: "list",
    attrs: {
      "accounts": _vm.selectedAccounts,
      "searchTypes": _vm.searchTypes,
      "jobType": 'virtualDevicesCsvImport'
    },
    on: {
      "load-items": _vm.getItemsResults,
      "show-item-info": _vm.showInfo
    }
  }) : _vm._e()], 1), _c(VTabItem, {
    key: "#bg-jobs-dtwin-duplicate",
    staticClass: "pt-3",
    attrs: {
      "value": "bg-jobs-dtwin-duplicate"
    }
  }, [_vm.accountFilterReady ? _c('core-background-jobs-table', {
    ref: "list",
    attrs: {
      "accounts": _vm.selectedAccounts,
      "searchTypes": _vm.searchTypes,
      "jobType": 'digitalTwinBulkDuplicate'
    },
    on: {
      "load-items": _vm.getItemsResults,
      "show-item-info": _vm.showInfo
    }
  }) : _vm._e()], 1)], 1)], 2)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };